import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { addCookies } from 'redux/actions/layoutActions';

import AuthHeader from 'shared/components/layout/AuthHeader';
import Footer from 'shared/components/layout/Footer';
import ConfigCookie from 'shared/components/layout/ConfigCookie';

const withLayoutAuth = (Component) => (props) => {
  const dispatch = useDispatch();
  const theme = useSelector((state) => state.theme);
  const layout = useSelector((state) => state.layout);
  const { cookies } = layout;

  const onAcceptCookies = () => {
    document.cookie = 'username=John Doe';
    dispatch(addCookies(document.cookie));
  };

  return (
    <>
      <div className={!cookies ? 'auth-layout-cookies cooking-display-wrap' : 'auth-layout'}>
        <AuthHeader
          logoSrc={theme.logoHeader}
          lineColor={theme.lineColorHeader}
          backgroundColor={theme.backgroundHeader}
        />
        <Component
          {...props}
          logoSrc={theme.logoHeader}
          mainColor={theme.mainColor}
          secondaryColor={theme.secondaryColor}
        />
        {cookies && (
          <Footer
            logoSrc={theme.logoFooter}
            backgroundColor={theme.backgroundFooter}
            footerText={theme.footerText}
            iconColor={theme.footerIconColor}
            textColor={theme.footerTextColor}
            facebookLink={theme.facebookLink}
            linkedinLink={theme.linkedinLink}
            youtubeLink={theme.youtubeLink}
            twitterLink={theme.twitterLink}
            phone={theme.phone}
            showLogoFooter={theme.showLogoFooter}
          />
        )}
      </div>
      {!cookies && <ConfigCookie onClick={() => onAcceptCookies()} />}
    </>
  );
};

export default withLayoutAuth;
